// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputCheckbox from '@/components/input/modules/checkbox'
import maAdminView from '../adminView'
import maEmpty from '@/components/empty'

// api
import {
  apiGetAdminDamagesParameters,
  apiPatchAdminDamagesParameters
} from '@/services/API/admin'

export default {
  name: 'parameters',
  data: function () {
    return {
      parameter: {
        paramName: null,
        paramValue: null,
        customizable: null
      }
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputCheckbox,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminDamagesParameters(this.currentPage)
        .then(parameters => {
          this.table = parameters.results
          this.totalPages = parameters.total_pages || 0
        })
    },
    handleEdit: function (paramName, paramValue, customizable) {
      this.parameter = { paramName, paramValue, customizable }
      this.$refs.adminEditModal.showModal = true
    },
    resetEditValues: function () {
      this.parameter.paramName = null
      this.parameter.paramValue = null
      this.parameter.customizable = null
    },
    handleSave: function () {
      apiPatchAdminDamagesParameters(
        this.parameter.paramName,
        this.parameter.paramValue,
        this.parameter.customizable
      )
        .then(() => {
          this.handleSearch()
          this.$refs.adminEditModal.showModal = false
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    }
  },
  mounted: function () {
    this.handleSearch()
  }
}
